<!--
 * @Description: In User Settings Edit
 * @Author: lic
 * @Date: 2019-07-23 09:55:56
 * @LastEditTime: 2019-10-22 04:08:52
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="activityDetail">
    <barrage v-if="isShowBarrage" top="0" :data="barrageArr"></barrage>
    <div id="head_swiper" class="swiper-container img_banner" v-show="!isShowLive">
      <div class="swiper-wrapper">
        <div class="swiper-slide " v-for="(item, index) in bannerList" :key="index"><img :src="item" alt="" />
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
      <!--  -->
      <div class="live_status" v-if="liveObj.status == 'PLAYING'">
        <img :src="picUrl.livegifs" alt="">
        <div class="live_name">{{liveObj.studioName}}</div>
        <div class="watch_btn" @click='goLiveRoom(liveObj.status)'>观看</div>
      </div>
    </div>
    <div v-if="isShowLive" id="id_test_video" style="width:100%; height:300px;"></div>
    <!-- 标题栏 -->
    <div class="title_banner">
      <div class="live_fixed" v-if="hasLive && !isShowLive" @click="changeLiveShow(true)">
        <img class="live_back" :src="picUrl.liveBack" alt="" />
        <img class="live_play" :src="picUrl.liveGif" alt="" />
      </div>
      <div class="live_fixed" v-if="hasLive && isShowLive" @click="changeLiveShow(false)"><img class="live_back" :src="picUrl.liveReturn" alt="" /></div>
      <div class="title_top">
        <div class="title_title">{{ activityData.activityName }}</div>
        <div class="title_line">
          <img :src="picUrl.hot" alt="" />
          <span>热度{{ activityData.activityHot }}</span>
          <img class="right" :src="picUrl.man" alt="" />
          <span>已报名{{ activityData.enrollQty }}人</span>
        </div>
      </div>
      <div class="title_time">
        <div class="time_line">
          <img :src="picUrl.time" alt="" />
          <div>
            报名时间
            <span>{{ activityData.enrollStartTimeDisplay }}- {{ activityData.enrollEndTimeDisplay }}</span>
          </div>
        </div>
        <div class="time_line">
          <img :src="picUrl.time" alt="" />
          <div>
            活动时间
            <span>{{ activityData.orderStartTime }}- {{ activityData.orderEndTime }}</span>
          </div>
        </div>
        <div class="time_line">
          <img :src="picUrl.location" alt="" />
          <div class="location_line">
            活动地址
            <span class="blue" v-if="activityLocationData" @click="navigateToActivity">{{ activityLocationData.title }}</span>
            <span v-else>全国</span>
          </div>
        </div>
      </div>
      <div class="title_rule" @click="showRuleAlert">
        <img :src="picUrl.icon_explain">
        活动规则
      </div>
    </div>
    <!-- 直播预告 -->
    <div class="liveWrap" v-if='liveObj' >
      <div class="liveTitle">
        <img :src="picUrl.title_live">
        <span>直播活动</span>
        <!-- <span>{{liveObj.studioName}}</span> -->
      </div>
      <div class="liveListWrap">
        <div class="liveTop">
          <div class="liveCover">
            <img :src="liveObj.liveCoverUrl" alt="">
            <div v-if="liveObj.status == 'WAITING' || liveObj.status == 'END'" class="CoverStatus bgWAITING">未开始 </div>
            <div v-else-if="liveObj.status == 'PLAYING'" class="CoverStatus bg">进行中</div>
            <div v-else-if="liveObj.status == 'POPULARIZE_ACTIVITY_END'" class="CoverStatus bgEND">已结束</div>
          </div>
          <div class="liveCoverTitle">{{liveObj.studioName}}</div>
          <div class="watch_btn" v-if="liveObj.status != 'POPULARIZE_ACTIVITY_END'" @click='goLiveRoom(liveObj.status)'>观看</div>
        </div>
        <div  v-for="(item, index) in liveObj.timeDescribe" :key="index">
          <ul v-show="isOpen || index < max">
              <!-- <li ><span>{{ item.label }}</span></li>
              <li ><span>{{ item.value }}</span></li> -->
              <li class="liveLists">
                <div class="status_spot">
                  <img class="spot" :src="liveObj.status == 'POPULARIZE_ACTIVITY_END'?picUrl.dot_gray:picUrl.dot_red" alt="">
                  <img class="spotLine" v-if="index < liveObj.timeDescribe.length-1 && liveObj.timeDescribe.length>1 " :src="liveObj.status == 'POPULARIZE_ACTIVITY_END'?picUrl.line_gray:picUrl.line_red" alt="">
                </div>
                <div class="liveSessions">
                  <div>{{item.describe}}</div>
                  <p :class="(!isOpen&&liveObj.timeDescribe.length>2 && index == 1)||index==liveObj.timeDescribe.length-1?'':'pbottom'">{{item.startTime}}~{{item.endTime}}</p>
                </div>
              </li>
          </ul>
        </div>
        <div class="seeBtn" v-show="!isOpen && liveObj.timeDescribe.length > max" @click="isOpen = !isOpen">查看更多<img :src="picUrl.shaink" /></div>
        <div class="seeBtn" v-show="isOpen && liveObj.timeDescribe.length > max" @click="isOpen = !isOpen">收起<img :src="picUrl.open"  /></div>
      </div>
    </div>
    <!-- 报名营销活动 -->
    <div class="act_banner activity_banner" v-if="activityList.length > 0">
      <img class="banner_img" :src="picUrl.activityTitle" alt="" />
      <div class="swiper">
        <div class="swiper-container" id="activity_banner">
          <div class="swiper-wrapper" style="padding-top: 20px">
            <div class="swiper-slide" v-for="(item, index) in activityList" :key="index">
              <div class="swiper_box">
                <img v-if="item.activityType == 'FULFIL_QUOTA'" :src="picUrl.actFul" alt="" />
                <img v-else-if="item.activityType == 'FREE'" :src="picUrl.actFree" alt="" />
                <img v-else :src="picUrl.actUnion" alt="" />
                <div>{{ item.activityName }}</div>
                <span>{{ item.startTime }}- {{ item.endTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 营销活动大礼包  -->
    <div class="act_banner coupon_banner" v-if="couponList.length > 0">
      <img class="banner_img" :src="picUrl.couponTitle" alt="" />
      <div class="swiper">
        <div class="swiper-container" id="coupon_banner">
          <div class="swiper-wrapper" style="padding-top: 20px">
            <div class="swiper-slide" v-for="(item, index) in couponList" :key="index" @click="clickToEnroll">
              <div class="swiper_box">
                <!-- <img class="ticket_back"
                     :src="picUrl.actTicket"
                     alt=""> -->
                <img class="coupon_back" :src="item.couponCover" alt="" />
                <div class="coupon_sourse">{{ item.mallName }}</div>
                <div class="coupon_title">{{ item.couponName }}</div>
                <div class="coupon_time">有效时间：{{ item.availableStartTime }} - {{ item.availableEndTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 富文本框内容  -->
    <div class="html_banner" v-if="activityData.activityContent && activityData.activityContent.length > 0"><div v-html="activityData.activityContent"></div></div>
    <!-- 参与品牌  -->
    <div class="brand_banner" v-if="storeInfo.length > 0">
      <div class="brand_header">
        <div>参与品牌</div>
        <img v-if="deviceType == 0" :src="picUrl.right" @click="viewMoreBrand" alt="" />
        <p v-if="deviceType == 0" @click="viewMoreBrand">更多品牌</p>
      </div>
      <div class="brand_list">
        <div class="brand_item" v-for="(item, index) in storeInfo" :key="index">
          <img :src="item.logoImage ? item.logoImage : picUrl.defaultImage" alt="" />
          <p>{{ item.storeName }}</p>
        </div>
      </div>
    </div>
    <!-- 已报名头像 -->
    <div class="icon_banner" v-if="avatarList.length > 0">
      <div class="icon_header">
        <div>已报名</div>
        <p>（{{ activityData.enrollQty }}）</p>
      </div>
      <div class="icon_group"><img v-for="(item, index) in avatarList" :key="index" class="icon_item" :src="item" alt="" /></div>
    </div>
    <!-- 空行 -->
    <div class="fixed_line_block"></div>
   <!-- 邀请您参加活动 -->
    <div class="invite_fixed" v-if="deviceType == 0 && activityData.promoterNickName && activityData.promoterNickName.length > 0">
      <div class="back"></div>
      <img :src="activityData.promoterAvatar ? activityData.promoterAvatar : picUrl.defaultImage" alt="" />
      <div class="box">
        <span>{{ activityData.promoterNickName }}</span>
        邀请您参加活动
      </div>
    </div>
    <!-- 立即报名 -->
    <div class="btn_fixed">
      <div v-if="deviceType !== 0 && dateType == -1" class="disable_btn">活动未开始</div>
      <div v-else-if="deviceType !== 0 && dateType == 1" class="disable_btn">活动已结束</div>
      <div v-else-if="deviceType !== 0" class="app_share_btn" @click="appShareClick">分享</div>
      <div v-else>
        <div class="share_btn" v-if="popularizeFlag" @click="startShare(true)">
          <img :src="picUrl.mianIcon" alt="" />
          推一下
        </div>
        <div v-if="dateType == -1" class="disable_btn" :class="{ is_show_share: popularizeFlag }">活动未开始</div>
        <div v-if="dateType == 1" class="disable_btn" :class="{ is_show_share: popularizeFlag }">活动已结束</div>
        <div v-else-if="motivateBuyType == 'ENROLL_INFO'" class="apply_btn" :class="{ is_show_share: popularizeFlag }" @click="viewApplyMessage">报名信息</div>
        <div v-else class="apply_btn" :class="{ is_show_share: popularizeFlag }" @click="getRedirectType">
          <div v-if="salesCouponPrice == 0">立即报名</div>
          <div v-else>
            <div class="btn_big">立即报名</div>
            <div class="btn_little">报名费￥{{ salesCouponPrice }} 报名费不退</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分享赚现金 -->
    <div id="share_alert" v-if="isShowShareAlert || isShowRule" @click.stop="startShare(false)"></div>
    <div class="rule_detail" v-if="isShowRule">
      <div class="rule_title">规则说明</div>
      <div class="rule_main">
        <div class="rule_detail_inner"><div v-html="activityData.activityRule"></div></div>
      </div>
      <div class="rule_btn" @click="startShare(false)">知道了</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import barrage from '@/components/barrage'
import Swiper from 'swiper'
let player = null
let timer = null
import { jsonDateFormat, getImageList, appShareClick } from '@/utils/index.js'
import { buriedPoint } from '@/utils/utils.js'
export default {
  name: 'activityDetail',
  components: {
    barrage
  },
  data() {
    return {
      /**
       * 推广弹窗
       */
      isShowShareAlert: false, // 是否展示推广弹窗
      isShowRule: false, // 是否展示规则

      /**
       * 静态图片
       */
      picUrl: {
        hot: this.$store.state.ossLink + 'activity/activity_icon_hot.png',
        man: this.$store.state.ossLink + 'activity/activity_icon_bm.png',
        time: this.$store.state.ossLink + 'icon_time.png',
        location: this.$store.state.ossLink + 'location.png',
        liveBack: this.$store.state.ossLink + 'activity/liveback.png?t=1',
        liveReturn: this.$store.state.ossLink + 'activity/livereturn.png?t=1',
        liveGif: this.$store.state.ossLink + 'activity/live.gif?t=1',
        activityTitle: this.$store.state.ossLink + 'activity/activity_title_new.png',
        couponTitle: this.$store.state.ossLink + 'activity/coupon_title.png',
        actFree: this.$store.state.ossLink + 'activity/act_free.png',
        actFul: this.$store.state.ossLink + 'activity/act_ful.png',
        actUnion: this.$store.state.ossLink + 'activity/act_union.png',
        actTicket: this.$store.state.ossLink + 'activity/act_ticket_new.png',
        right: this.$store.state.ossLink + 'activity/right.png',
        shareLight: this.$store.state.ossLink + 'activity/share_light.png',
        backIcon: this.$store.state.ossLink + 'share/share_one_btn_back-left.png',
        shareTitle: this.$store.state.ossLink + 'activity/share_title.png',
        mianIcon: this.$store.state.ossLink + 'activity/icon_mian.png',
        defaultImage: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/cimen/share.png',
        liveTitle:this.$store.state.ossLink + 'live/H5_title_live@2x.png',
        icon_explain:this.$store.state.ossLink + 'live/icon_explain@2x.png',
        title_live:this.$store.state.ossLink + 'live/title_live@2x.png',
        open:this.$store.state.ossLink + 'live/open@2x.png',
        shaink:this.$store.state.ossLink + 'live/shaink@2x.png',
        dot_red:this.$store.state.ossLink + 'live/dot_red@2x.png',
        line_red:this.$store.state.ossLink + 'live/line_red@2x.png',
        livegifs:this.$store.state.ossLink + 'live/livegif.gif',
        line_gray:this.$store.state.ossLink + 'live/line_gray@2x.png',
        dot_gray:this.$store.state.ossLink + 'live/dot_gray@2x.png',
        
      },
      /**
       * 页面数据
       */
      activityData: {}, // 页面数据
      isShowBarrage: false,
      barrageArr: [], // 弹幕集合
      bannerList: [], // 顶部swiper
      activityList: [], // 营销活动
      couponList: [], // 卡券列表
      storeInfo: [], // 参与店铺集合
      avatarList: [], // 报名头像集合
      /**
       * 下方按钮判断条件
       */
      popularizeFlag: true, // 是否推广
      dateType: 0, // 活动时间判断
      salesCouponPrice: 0, // 报名费
      mallId: 0, // 商场编号
      /**
       * BUY("立即抢购"),
       * ENROLL("立即报名"),
       * ENROLL_AND_GET("立即报名领取"),
       * ENROLL_AND_BUY("立即报名抢购"),
       * ENROLL_INFO("报名信息");）
       * 如果接口返回ENROLL_INFO，那按钮显示报名信息，其余情况根据返回报名费展示按钮。
       */
      motivateBuyType: '', // 蓄客购买类型
      activityLocationData: null, // 活动地址
      deviceType: 0, // 设备类型
      /**
       * 直播相关参数
       */
      hasLive: false, //是否绑定直播 直播是否在进行中
      isShowLive: false, // 是否显示直播
      isPlay: false, // 是否正在播放
      playTime: 0, // 当前播放时长
      playTimeDefault: 0, // 播放开始时长
      playStartTime: 0, //播放开始时间
      livePullUrl: '', //拉流地址
      liveWatchTime: 0, // 直播需要观看时间
      nowLocationData: {
        // 当前位置信息
        latitude: '',
        longitude: ''
      },
      isRewardLivePresent: false, // 是否已经获得直播奖励
      liveObj: '',//直播数据
      liveActivityId: '',

      max: 2, // 默认最多显示的个数；最大行数*每行显示的个数 Number 
      isOpen: false, // 是否展开全部信息的标识 Boolean 默认false
    }
  },
  methods: {
    /**
     * 点击推广按钮
     */
    startShare(val) {
      if (val) {
        this.isShowFirendUsedTicket = false
        this.registerStarGuestInfo()
      } else {
        this.isShowShareAlert = val
        this.isShowRule = false
      }
    },
    /**
     * 是否展示规则
     */
    showRuleAlert() {
      this.isShowRule = true
    },
    /**
     * 分享弹窗中
     * 是否展示好友使用券
     */
    showFirendTicket(val) {
      this.isShowFirendUsedTicket = val
    },
    appShareClick() {
      appShareClick()
    },
    /**
     * 点击更多品牌
     * 跳转到品牌页面
     */
    viewMoreBrand() {
      this.$router.push('/activityBrand')
    },
    /**
     * 查看报名信息
     */
    viewApplyMessage() {
      this.$router.push('/activityRegisterDetail')
    },
    /**
     * 页面上Swiper组件重置
     */
    refreshSwiperScroll() {
      let self = this
      this.$nextTick(() => {
        if (self.barrageArr.length > 1) {
          this.isShowBarrage = true
        }
        if (self.bannerList.length > 1) {
          var mySwiper = new Swiper('#head_swiper', {
            loop: true,
            autoplay: true,
            // 如果需要分页器
            pagination: {
              el: '.swiper-pagination'
            }
          })
        }
        if (self.activityList.length > 0) {
          var mySwiper2 = new Swiper('#activity_banner', {
            centeredSlides: true,
            watchActiveIndex: true,
            spaceBetween: 13,
            slidesPerView: 2,
            slidesPerView: 'auto'
          })
        }
        if (self.couponList.length > 0) {
          var mySwiper3 = new Swiper('#coupon_banner', {
            centeredSlides: true,
            watchActiveIndex: true,
            spaceBetween: 0,
            slidesPerView: 2,
            slidesPerView: 'auto'
          })
        }
      })
    },
    /* eslint-enable */
    /**
     * 获取openid
     */
    getOpenId () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            localStorage.setItem('share_saleOrgNo', res.data.starGuestNo)
            localStorage.setItem('WECHAT_OPEN_ID', res.data.starGuestNo)
            localStorage.setItem('share_saleOrgType', 'STAR_GUEST')
            localStorage.setItem('share_clerkId', '')
            this.$router.push({ path: '/activityShare', query: { popularizeNo: self.activityData.popularizeNo, popularizeId: self.activityData.popularizeId } })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getShareInfo (shareTitle, shareText, shareImage) {
      // 获取分享海报的内容
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/share/to/picture',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : ''
          }
        })
        .then(res => {
          if (res.success) {
            self.wxShare(shareTitle, shareText, shareImage, res.data.qrCodeUrl)
          } else {
            self.wxShare(shareTitle, shareText, shareImage, null)
          }
        })
        .catch(err => {
          console.log(err)
          self.wxShare(shareTitle, shareText, shareImage, null)
        })
    },
    /**
     * 判断是否已经是星客
     */
    getIsStarGuestResquest (shareTitle, shareText, shareImage) {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/alliance2/star/guest/check/is/star/guest'
        })
        .then(res => {
          if (res.success && res.data) {
            self.getShareInfo(shareTitle, shareText, shareImage)
          } else {
            self.wxShare(shareTitle, shareText, shareImage, null)
          }
        })
        .catch(err => {
          console.log(err)
          self.wxShare(shareTitle, shareText, shareImage, null)
        })
    },
    /**
     * /h5/star/alliance2/star/guest/register/star/guest/info
     * 注册星客
     */
    registerStarGuestInfo () {
      let isStar = localStorage.getItem('IS_CIMEN_STAR_USER')
      let self = this
      if (isStar && isStar === 'TRUE') {
        self.getOpenId()
      }
      let sourceType = localStorage.getItem('saleOrgType')
      let sourceNo = localStorage.getItem('saleOrgNo')
      if (sourceType === 'STORE') {
        let clerkId = localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : ''
        sourceNo = clerkId
      }
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/register/star/guest/info',
          params: {
            sourceType: sourceType,
            sourceNo: sourceNo,
            sourceActivityId: localStorage.getItem('activityId')
          }
        })
        .then(res => {
          if (res.success) {
            localStorage.setItem('IS_CIMEN_STAR_USER', 'TRUE')
            self.getOpenId()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * h5获取蓄客活动信息
     */
    getActivityInfo () {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/query/info',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId')
          }
        })
        .then(res => {
          if (res.success) {
            if (self.deviceType === 0 && res.data.domain && res.data.domain !== location.host) {
              let linkUrl =
                document.location.protocol +
                '//' +
                res.data.domain +
                '/index.html#/?saleOrgType=' +
                localStorage.getItem('saleOrgType') +
                '&saleOrgNo=' +
                localStorage.getItem('saleOrgNo') +
                '&activityId=' +
                localStorage.getItem('activityId') +
                '&clerkId=' +
                (localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '') +
                '&wechatId=' +
                localStorage.getItem('wechatId')
              location.href = linkUrl
            }
            self.activityData = res.data

            document.title = res.data.activityName // 标题设置为活动名称

            // bulletScreen 弹幕
            if (res.data.bulletScreen && res.data.bulletScreen.length > 0) {
              self.barrageArr = res.data.bulletScreen
            } else {
              self.barrageArr = []
            }

            // backgroundUrl 背景图
            self.bannerList = res.data.backgroundUrl.split(',')

            // 时间格式处理
            self.activityData.enrollStartTimeDisplay = jsonDateFormat(self.activityData.enrollStartTime, 'minute')
            self.activityData.enrollEndTimeDisplay = jsonDateFormat(self.activityData.enrollEndTime, 'minute')
            self.activityData.orderStartTime = jsonDateFormat(self.activityData.orderStartTime, 'minute')
            self.activityData.orderEndTime = jsonDateFormat(self.activityData.orderEndTime, 'minute')

            // 营销活动
            if (res.data.activityList && res.data.activityList.length > 0) {
              res.data.activityList.forEach(item => {
                item.startTime = jsonDateFormat(item.startTime, 'minute')
                item.endTime = jsonDateFormat(item.endTime, 'minute')
              })
              self.activityList = res.data.activityList
            } else {
              self.activityList = []
            }

            // 卡券
            if (res.data.couponList && res.data.couponList.length > 0) {
              res.data.couponList.forEach(item => {
                item.availableStartTime = jsonDateFormat(item.availableStartTime, 'date2')
                item.availableEndTime = jsonDateFormat(item.availableEndTime, 'date2')
              })
              self.couponList = res.data.couponList
            } else {
              self.couponList = []
            }

            // 参与店铺集合
            if (res.data.storeInfo && res.data.storeInfo.length > 0) {
              if (res.data.storeInfo.length > 5) {
                self.storeInfo = res.data.storeInfo.slice(0, 5)
              } else {
                self.storeInfo = res.data.storeInfo
              }
            } else {
              self.storeInfo = []
            }

            // 头像集合
            if (res.data.avatarList && res.data.avatarList.length > 0) {
              self.avatarList = getImageList(res.data.avatarList, self.activityData.enrollQty, 11)
            } else {
              self.avatarList = []
            }

            // 报名按钮
            self.motivateBuyType = res.data.motivateBuyType
            self.salesCouponPrice = res.data.salesCouponPrice
            if (res.data.payObj && res.data.payObj === 'MERCHANT') {
              self.salesCouponPrice = 0
            }
            self.mallId = res.data.mallId
            let nowDate = new Date().getTime() / 1000
            if (parseInt(self.activityData.enrollStartTime) > nowDate) {
              self.dateType = -1
            } else if (parseInt(self.activityData.enrollEndTime) < nowDate) {
              self.dateType = 1
            } else {
              self.dateType = 0
            }
            self.popularizeFlag = res.data.popularizeFlag
            self.popularizeId = res.data.popularizeId
            self.refreshSwiperScroll()

            // 活动地址
            if (res.data.activityAddr && res.data.activityAddr.length > 0) {
              self.activityLocationData = JSON.parse(res.data.activityAddr)
            } else {
              self.activityLocationData = null
            }

            // 微信分享
            if (self.deviceType === 0) {
              self.getIsStarGuestResquest(res.data.shareTitle, res.data.shareText, res.data.shareImage)
            }
            // 默认不显示直播播放器
            self.changeLiveShow(false)
            // 判断是否有
            if (res.data.liveActivityId) {
              self.getliveDetail(res.data.liveActivityId)
              self.liveActivityId = res.data.liveActivityId
            }
            // 判断该活动是否存在直播
            // if (res.data.isAllowLive) {
            //   self.isRewardLivePresent = false
            //   self.breathToGetLiveDetail()
            // }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 定时获取直播是否在进行中
     */
    breathToGetLiveDetail () {
      let self = this
      self.requestGetLiveDetail()
      self.clearTimeInterval()
      timer = setInterval(() => {
        self.requestGetLiveDetail()
      }, 10000)
    },
    /**
     * 获取直播信息
     * /h5/star/task/popularize/watch/live/prize/config
     * popularizeId
     */
    requestGetLiveDetail () {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/popularize/watch/live/prize/config',
          params: {
            popularizeId: self.popularizeId
          }
        })
        .then(res => {
          if (res.success) {
            self.dealWithLiveDetail(res.data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 处理直播信息
     */
    dealWithLiveDetail (liveDetail) {
      if (!liveDetail.isAllowLive) {
        // 该活动不允许直播
        this.clearTimeInterval()
        return
      }
      if (liveDetail.isLiving) {
        // 如果直播进行中
        this.hasLive = true
        this.livePullUrl = liveDetail.pullAddress
        this.liveWatchTime = liveDetail.watchTime
      } else {
        if (this.hasLive) {
          this.$weui.toast('当前直播已结束', {
            duration: 2000,
            className: 'toast_text'
          })
          this.changePlay(false)
        }
        // 如果直播不在进行中 / 结束
        this.hasLive = false
        this.changeLiveShow(false)
      }
    },
    /**
     * 点击切换直播组件 并创建播放器
     */
    changeLiveShow (isShowLive) {
      this.isShowLive = isShowLive
      this.refreshSwiperScroll()
      let self = this
      if (isShowLive) {
        this.$nextTick(() => {
          self.startLivePlay()
        })
      } else {
        if (player) player.destroy()
      }
    },
    /**
     * 开启直播
     */
    /* eslint-disable */
    startLivePlay() {
      let self = this
      // console.log(player)
      // if (player) player.destroy()
      self.changePlay(false)
      // console.log(self.livePullUrl)
      player = new TcPlayer('id_test_video', {
        m3u8: self.livePullUrl, //请替换成实际可用的播放地址
        autoplay: true, //iOS 下 safari 浏览器是不开放这个能力的
        live: true,
        x5_type: 'h5-page',
        poster: { style: 'stretch', src: self.bannerList[0] },
        wording: {
          2032: '请求视频失败，请检查网络',
          2048: '请求m3u8文件失败，可能是网络错误或者跨域问题'
        },
        listener: msg => {
          if (self.dateType == 0) self.dealWithPlayerMessage(msg)
        }
      })
    },
    /* eslint-enable */
    changePlay (isPlay) {
      this.isPlay = isPlay
      if (!isPlay) {
        this.playTime = 0 // 当前播放时长
        this.playStartTime = 0 // 播放开始时间
        this.playTimeDefault = 0
      }
    },
    dealWithPlayerMessage (message) {
      let self = this
      if (message.type === 'timeupdate') {
        // 开始直播拉流
        self.startPullLive(message.timeStamp)
      } else if (message.type === 'pause') {
        // 视频暂停
        self.changePlay(false)
      } else if (message.type === 'playing') {
        // 视频播放
        self.changePlay(true)
      } else if (message.type !== 'progress') {
        console.warn(message)
      }
    },
    /**
     * 开始视频拉流 并统计时间
     */
    startPullLive (timeStamp) {
      if (!this.isPlay) return
      if (this.playTimeDefault === 0) {
        this.playTimeDefault = timeStamp // 毫秒
        this.playStartTime = new Date().valueOf()
      }
      this.playTime = timeStamp - this.playTimeDefault // 毫秒
      // console.log(this.playTime)
      if (this.playTime > this.liveWatchTime * 1000) {
        this.requestGetLiveRewards()
      }
    },
    /**
     * 请求直播奖励接口
     * /h5/star/task/enroll/handler/activity/watch/live
     */
    requestGetLiveRewards () {
      let self = this
      if (this.isRewardLivePresent) {
        return
      }
      this.isRewardLivePresent = true
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/handler/activity/watch/live',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '',
            latitude: self.nowLocationData.latitude,
            longitude: self.nowLocationData.longitude,
            playStartTime: self.playStartTime
          }
        })
        .then(res => {
          if (res.success) {
            console.log('请求直播奖励接口')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 导航到活动地址
     */
    navigateToActivity () {
      let self = this
      const wechatMapKey = self.$store.state.qqMapSDK
      let navigateUrl = `https://apis.map.qq.com/tools/routeplan/eword=${self.activityLocationData.title}&epointx=${self.activityLocationData.location.lng}&epointy=${
        self.activityLocationData.location.lat
      }?referer=myapp&key=${wechatMapKey}`
      location.href = navigateUrl
    },
    clickToEnroll () {
      let self = this
      if (self.deviceType !== 0) return
      let contentText = '需要报名后才能领取哟~'
      if (self.salesCouponPrice !== 0) {
        contentText += '报名费￥' + self.salesCouponPrice + '，报名费不予退还'
      }
      if (self.dateType === -1) {
        this.$weui.dialog({
          title: '提示',
          content: '报名活动还未开始哦！',
          className: 'custom-classname',
          buttons: [
            {
              label: '知道了',
              type: 'primary',
              onClick: function () {
                console.log('ok')
              }
            }
          ]
        })
        return
      } else if (self.dateType === 1) {
        this.$weui.dialog({
          title: '提示',
          content: '报名活动已结束！',
          className: 'custom-classname',
          buttons: [
            {
              label: '知道了',
              type: 'primary',
              onClick: function () {
                console.log('ok')
              }
            }
          ]
        })
        return
      }
      self.$weui.dialog({
        title: '提示',
        content: contentText,
        className: 'custom-classname',
        buttons: [
          {
            label: '暂不领取',
            type: 'default',
            onClick: function () {
              console.log('cancel')
            }
          },
          {
            label: '立即报名',
            type: 'primary',
            onClick: function () {
              console.log('ok')
              self.getRedirectType()
            }
          }
        ]
      })
    },
    /**
     * h5获取蓄客活动购买跳转类型
     */
    getRedirectType () {
      this.$router.push('/activityRegisterSubmit')
    },
    /**
     * /h5/star/task/enroll/handler
     * h5报名
     */
    motivationActivityEnroll () {
      // 提交
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/enroll/handler',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '',
            mallId: self.mallId, // 商场编号
            salesCouponPrice: self.salesCouponPrice, // 付款金额
            motivateBuyType: self.motivateBuyType // 报名购买类型
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              var urlType = res.data.split('type=')[1]
              if (urlType === 'ENROLL_DIALOG') {
                self.$weui.dialog({
                  title: '提示',
                  content: '报名成功！',
                  className: 'custom-classname',
                  buttons: [
                    {
                      label: '确定',
                      type: 'primary',
                      onClick: function () {
                        console.log('ok')
                      }
                    }
                  ]
                })
              } else {
                window.location.href = res.data
              }
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/task/enroll/handler/activity/read
     * 阅读奖励（获取位置后调用）
     */
    getLocationRequest (latitude, longitude) {
      let self = this
      self.nowLocationData = {
        latitude: latitude,
        longitude: longitude
      }
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/handler/activity/read',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '',
            latitude: latitude,
            longitude: longitude
          }
        })
        .then(res => {
          if (res.success) {
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    wxShare (shareTitle, shareText, shareImage, shareSpecLink) {
      localStorage.setItem('STAR_ACTIVITY_SHARE_TITLE', shareTitle)
      localStorage.setItem('STAR_ACTIVITY_SHARE_TEXT', shareText)
      localStorage.setItem('STAR_ACTIVITY_SHARE_IMAGE', shareImage)
      let self = this
      let shareUrlNew =
        document.location.protocol +
        '//' +
        location.host +
        '/index.html#/?saleOrgType=' +
        localStorage.getItem('saleOrgType') +
        '&saleOrgNo=' +
        localStorage.getItem('saleOrgNo') +
        '&activityId=' +
        localStorage.getItem('activityId') +
        '&clerkId=' +
        (localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '')
      let shareUrl = shareUrlNew
      if (shareSpecLink) {
        shareUrl = shareSpecLink
      }
      console.log(localStorage.getItem('wechatId'))
      self.$fly
        .request({
          method: 'get',
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: localStorage.getItem('activityId') === '1509',
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'hideMenuItems',
                'showMenuItems',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'getLocation'
              ]
            })
            self.$wx.ready(function () {
              self.$wx.hideAllNonBaseMenuItem()
              self.$wx.showMenuItems({
                menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3 ,
              })
              // 隐藏分享
              self.$wx.getLocation({
                type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function (res) {
                  console.log(res)
                  var latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
                  var longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
                  // var speed = res.speed; // 速度，以米/每秒计
                  // var accuracy = res.accuracy; // 位置精度
                  if (res.latitude && res.longitude) {
                    self.getLocationRequest(latitude, longitude)
                  }
                },
                fail: function (res) {
                  console.log(res)
                  self.getLocationRequest('', '')
                }
              })
              self.$wx.updateAppMessageShareData({
                title: shareTitle, // 分享标题
                desc: shareText, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                },
                fail: function () {
                  self.$wx.onMenuShareAppMessage({
                    title: shareTitle, // 分享标题
                    desc: shareText, // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareImage, // 分享图标
                    success: function () {
                      // 设置成功
                    },
                    fail: function () {
                      window.location.reload()
                    }
                  })
                }
              })
              self.$wx.updateTimelineShareData({
                title: shareTitle, // 分享标题
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
              self.$wx.onMenuShareTimeline({
                title: shareTitle, // 分享标题
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 用户点击了分享后执行的回调函数
                }
              })
              self.$wx.onMenuShareAppMessage({
                title: shareTitle, // 分享标题
                desc: shareText, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    clearTimeInterval () {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    },
    /**
     * 获取直播信息
     */
    getliveDetail (studioId) {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/star/live/manage/star/live/studio/detail/info/for/h5',
          params: {
            studioId: studioId
          }
        })
        .then(res => {
          if (res.success) {
            res.data.timeDescribe.forEach(item => {
              item.startTime = jsonDateFormat(item.startTime, 'minute')
              item.endTime = jsonDateFormat(item.endTime, 'minute')
            })
            this.liveObj = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 去直播间，判断直播状态
    goLiveRoom (status) {
      buriedPoint('LIVE_AD', this.liveObj.studioCode)
      this.$router.push('/living?studioCode=' + this.liveObj.studioCode + '&liveActivityId=' + this.liveActivityId + '&saleOrgType=' +
                localStorage.getItem('saleOrgType') + '&saleOrgNo=' + localStorage.getItem('saleOrgNo') + '&activityId=' + localStorage.getItem('activityId'))
      // if (status === 'WAITING') {
      //   this.$weui.toast('直播未开始', {
      //     duration: 2000,
      //     className: 'weui-toast-center'
      //   })
      // } else if (status === 'PLAYING') {
      //   this.$router.push('/living?studioCode=' + this.liveObj.studioCode + '&activityId=' + this.liveActivityId)
      // } else if (status === 'END') {
      //   this.$weui.toast('直播已结束', {
      //     duration: 2000,
      //     className: 'weui-toast-center'
      //   })
      // }
    }
  },
  mounted () {

  },
  beforeRouteLeave (to, form, next) {
    this.clearTimeInterval()
    next()
  },
  activated () {
    let self = this
    self.deviceType = parseInt(localStorage.getItem('USER_DEVICE_TYPE'))
    /* if (self.$route.query.code && self.$route.query.code !== localStorage.getItem('authorCode')) {
      localStorage.setItem('authorCode', self.$route.query.code)
    } */
    if (self.$route.query.activityId) {
      // url参数有activityId时重新存缓存
      localStorage.setItem('activityId', self.$route.query.activityId)
      localStorage.removeItem('saleOrgType')
      localStorage.removeItem('saleOrgNo')
      localStorage.removeItem('clerkId')
      if (self.$route.query.saleOrgType) {
        localStorage.setItem('saleOrgType', self.$route.query.saleOrgType)
      }
      if (self.$route.query.saleOrgNo) {
        localStorage.setItem('saleOrgNo', self.$route.query.saleOrgNo)
      }
      if (self.$route.query.clerkId && self.$route.query.clerkId !== '' && Number.isInteger(parseInt(self.$route.query.clerkId))) {
        localStorage.setItem('clerkId', self.$route.query.clerkId)
      }
    }
    self.getActivityInfo()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#activityDetail {
  width: 100%;
}

#head_swiper .swiper-slide img {
  width: 100%;
  display: block;
  border: none;
}
.img_banner{
  position: relative;
  .live_status{
    position: absolute;
    max-width: 700px;
    height: 80px;
    background: rgba(0,0,0,0.75);
    border-radius: 40px;
    right: 24px;
    bottom: 12px;
    color: #ffffff;
    display: flex;
    align-items: center;
    z-index: 999;
    img{
      width: 20px !important;
      height: 16px;
      margin: auto 8px auto 22px;
    }
    .live_name{
      max-width: 520px;
      margin-right: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .watch_btn{
      // width: 96px;
      width: 96px;
      height: 52px;
      // padding: 12px 22px;
      background: linear-gradient(270deg,#fa865f, #eb263b);
      border-radius: 26px;
      text-align: center;
      line-height: 52px;
      font-size: 26px;
      margin-right: 20px;
    }
  }
}
.title_banner {
  width: 100%;
  height: 388px;
  background-color: #fff;
  position: relative;
  .live_fixed {
    position: absolute;
    right: 20px;
    top: 80px;
    width: 80px;
    height: 96px;
    z-index: 9999999;
      .live_back {
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .live_play {
        position: absolute;
        left: 5px;
        top: 10px;
        width: 70px;
        height: 40px;
      }
    }
  .title_top {
    margin-left: 20px;
    width: calc(100% - 40px);
    height: 156px;
    border-bottom: 1px solid #eee; /* no */
    .title_title {
      font-size: 30px;
      color: #333333;
      line-height: 30px;
      padding-top: 40px;
      max-width: calc(100% - 120px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title_line {
      margin-top: 26px;
      line-height: 25px;
      height: 25px;
      font-size: 26px;
      color: #333333;
      img {
        width: 25px;
        height: 25px;
      }
      .right {
        margin-left: 35px;
      }
    }
  }
  .title_time {
    .time_line {
      margin-top: 36px;
      height: 30px;
      width: 100%;
      line-height: 0;
      img {
        margin-left: 25px;
        display: block;
        float: left;
        width: 30px;
        height: 30px;
      }
      div {
        margin-left: 16px;
        display: block;
        float: left;
        font-size: 28px;
        color: #999999;
        padding: 15px 0;
      }
      .location_line {
        width: calc(100% - 100px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        margin-left: 18px;
        color: #333333;
        padding: 15px 0;
      }
      .blue {
        color: #02a7f0;
        text-decoration: underline;
      }
    }
  }
  .title_rule {
    position: absolute;
    right: 0;
    top: 33px;
    font-family: PingFang-SC-Bold;
    color: #333333;
    text-align: center;
    width: 164px;
    height: 42px;
    background-color: #f6f6f6;
    // background-blend-mode: normal, normal;
    border-radius: 22px 0px 0px 22px;
    display: flex;
    // justify-content: center;
    align-items: center;
    img{
      width: 32px;
      height: 34 px;
      margin: auto 4px auto 12px;
    }
  }
}
.activity_banner {
  margin-top: 16px;
  width: 100%;
  height: 288px;
  background-color: #fff;
  .swiper_box {
    width: 520px;
    height: 146px;
    background-color: #fff;
    border-radius: 10px;
    border: solid 1px #eeeeee; /* no */
    position: relative;
    img {
      position: absolute;
      left: 20px;
      top: 30px;
      height: 40px;
    }
    div {
      position: absolute;
      left: 140px;
      top: 30px;
      height: 40px;
      line-height: 40px;
      font-size: 30px;
      color: #333333;
      max-width: calc(100% - 160px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span {
      font-size: 22px;
      position: absolute;
      left: 40px;
      top: 93px;
      line-height: 18px;
      color: #999999;
    }
  }
  .swiper-slide-active {
    border-radius: 10px;
    box-shadow: 0px 4px 12px 0px rgba(249, 54, 11, 0.35);
  }
}
.act_banner {
  .banner_img {
    padding-top: 24px;
    width: 100%;
  }
  .swiper-container {
    height: 260px;
  }
  .swiper-slide {
    width: auto;
    height: 146px;
  }
}
.coupon_banner {
  margin-top: 16px;
  width: 100%;
  height: 336px;
  background-color: #fff;
  .swiper_box {
    width: 552px;
    height: 210px;
    background-color: #fff;
    position: relative;
    background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/activity/act_ticket_new.png');
    background-repeat: no-repeat;
    background-size: 100%;
    .ticket_back {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .coupon_back {
      position: absolute;
      left: 40px;
      top: 40px;
      width: 137px;
      height: 91px;
    }
    .coupon_sourse {
      position: absolute;
      left: 192px;
      top: 50px;
      line-height: 30px;
      font-size: 30px;
      color: #333333;
    }
    .coupon_title {
      position: absolute;
      left: 193px;
      top: 94px;
      font-size: 26px;
      color: #333333;
      line-height: 28px;
      max-width: calc(100% - 300px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        color: #fe5f5e;
      }
    }
    .coupon_time {
      position: absolute;
      left: 37px;
      top: 150px;
      line-height: 21px;
      font-size: 22px;
      color: #999999;
    }
  }
}
.html_banner {
  margin-top: 16px;
  width: calc(100% - 40px);
  background-color: #fff;
  padding: 20px;
  img {
    display: block;
  }
}
.brand_banner {
  margin-top: 16px;
  width: 100%;
  height: 280px;
  background-color: #fff;
  .brand_header {
    height: 85px;
    width: 100%;
    overflow: hidden;
    div {
      margin-left: 21px;
      float: left;
      line-height: 85px;
      height: 85px;
      font-size: 26px;
      color: #333333;
    }
    p {
      margin-right: 21px;
      float: right;
      line-height: 85px;
      height: 85px;
      font-size: 26px;
      color: #666666;
    }
    img {
      margin-right: 21px;
      margin-top: 30px;
      float: right;
      width: 13px;
      height: 24px;
    }
  }
  .brand_list {
    margin-top: 6px;
    height: 188px;
    margin-left: 20px;
    width: calc(100% - 40px);
    overflow: hidden;
    .brand_item {
      width: 108px;
      margin-left: calc((100% - 540px) / 4);
      float: left;
      height: 200px;
      img {
        width: 108px;
        height: 108px;
      }
      p {
        font-size: 26px;
        color: #333333;
        max-width: 108px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .brand_item:first-child {
      margin-left: 0;
    }
  }
}
.icon_banner {
  margin-top: 16px;
  width: 100%;
  height: 226px;
  background-color: #fff;
  .icon_header {
    height: 85px;
    width: 100%;
    overflow: hidden;
    div {
      margin-left: 21px;
      float: left;
      line-height: 85px;
      height: 85px;
      font-size: 26px;
      color: #333333;
    }
    p {
      margin-right: 21px;
      float: right;
      line-height: 85px;
      height: 85px;
      font-size: 26px;
      color: #666666;
    }
  }
  .icon_group {
    margin-top: 20px;
    height: 88px;
    margin-left: 20px;
    width: calc(100% - 40px);
    .icon_item {
      margin-left: calc((100% - 970px) / 10);
      float: left;
      width: 80px;
      height: 80px;
      border: 4px solid #fff;
      border-radius: 50%;
    }
    .icon_item:first-child {
      margin-left: 0;
    }
  }
}
.fixed_line_block {
  width: 100%;
  height: 256px;
}

.invite_fixed {
  z-index: 999;
  position: fixed;
  height: 104px;
  left: 0;
  width: 100%;
  bottom: 138px;
  .back {
    position: absolute;
    top: 0;
    left: 0;
    height: 104px;
    width: 100%;
    background-color: #000000;
    opacity: 0.5;
  }
  img {
    position: absolute;
    left: 19px;
    top: 22px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .box {
    position: absolute;
    left: 90px;
    top: 0;
    width: calc(100% - 100px);
    height: 104px;
    line-height: 104px;
    font-size: 30px;
    color: #ffffff;
    span {
      color: #e5c483;
    }
  }
}
.btn_white {
  z-index: 999;
  position: fixed;
  height: 40px;
  background-color: #fff;
  left: 0;
  width: 100%;
  bottom: 0;
}
.btn_fixed {
  z-index: 999;
  position: fixed;
  height: 138px;
  background-color: #fff;
  left: 0;
  width: 100%;
  bottom: 0;
  .share_btn {
    display: block;
    width: 250px;
    background-color: #fff;
    height: 138px;
    line-height: 138px;
    font-size: 32px;
    color: #fa7000;
    text-align: center;
    float: left;
    img {
      width: 40px;
      height: 30px;
    }
  }
  .apply_btn {
    width: 100%;
    height: 138px;
    background-image: linear-gradient(90deg, #ffb700 0%, #ff3833 100%), linear-gradient(#ff000c, #ff000c);
    background-blend-mode: normal, normal;
    line-height: 138px;
    text-align: center;
    font-size: 32px;
    color: #ffffff;
    .btn_big {
      padding-top: 30px;
      line-height: 30px;
    }
    .btn_little {
      line-height: 23px;
      margin-top: 21px;
      font-size: 24px;
      color: #f6e6c3;
    }
  }
  .disable_btn {
    width: 100%;
    height: 138px;
    background: #999;
    line-height: 138px;
    text-align: center;
    font-size: 32px;
    color: #ffffff;
  }
  .app_share_btn {
    width: 100%;
    height: 138px;
    background: rgb(70, 209, 191);
    line-height: 138px;
    text-align: center;
    font-size: 32px;
    color: #ffffff;
  }
  .disable_click {
    background: #999999;
  }
  .is_show_share {
    float: left;
    display: block;
    width: calc(100% - 250px);
  }
}
#share_alert {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  width: 100%;
  height: 100vh;
  background-color: #000000;
  opacity: 0.7;
}
.rule_detail {
  position: fixed;
  top: 25%;
  height: 50%;
  left: 14%;
  width: 72%;
  z-index: 99999;
  background: #fff;
  border-radius: 10px;
  .rule_btn {
    color: #f6e6c3;
    position: absolute;
    bottom: 14px;
    height: 72px;
    line-height: 72px;
    text-align: center;
    left: calc(50% - 200px);
    width: 400px;
    font-size: 32px;
    border-radius: 36px;
    background-image: linear-gradient(90deg, #ffb700 0%, #ff3833 100%), linear-gradient(#ffffff, #ffffff);
  }
  .rule_title {
    color: #000;
    font-family: PingFangSC-Medium;
    position: absolute;
    top: 20px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    width: 100%;
    font-size: 32px;
  }
  .rule_main {
    position: absolute;
    left: 40px;
    width: calc(100% - 80px);
    top: 100px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 200px);
    .rule_detail_inner {
      min-height: calc(100% + 1px);
      font-size: 30px;
    }
  }
}
.liveWrap{
  // max-height: 338px;
  padding-bottom: 20px;
  box-sizing:border-box;
  background: #ffffff; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  .liveTitle{
    display: flex;
    align-items:center;
    padding:36px 43px 18px 30px;
    // background-image:url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/live/H5_narrow@2x.png');
    background-repeat:no-repeat;
    background-size:24px 24px;
    background-position: 700px 40px;
    box-sizing:border-box;
    img{
      display: block;
      width: 44px;
      margin-right: 14px
    }
    span{
      font-size: 30px;
      color: #333;
      font-weight: 600;
      width: 442px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      line-height: 30px;
    }
  }
  .liveListWrap{
    // padding:0px 28px;
    .liveTop{
      width: 710px;
      height: 134px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0px 6px 14px 0px rgba(153,153,153,0.20);
      margin: 12px auto 24px;
      display: flex;
      align-items: center;
      .liveCover{
        width: 180px;
        height: 102px;
        margin-left: 16px;
        position: relative;
        img{
          width: 100%;
          height: 100%;
          border-radius: 12px;
        }
        .CoverStatus{
          position: absolute;
          left: 0;
          top: 0;
          color: #ffffff;
          text-align: center;
          width: 78px;
          height: 32px;
          font-size: 22px;
          line-height: 32px;
          border-radius: 8px 0px 8px 0px;
        }
        .bgWAITING{
          background: linear-gradient(270deg,#3bdabe, #10c1bb 3%);
        }
        .bg{
          background: linear-gradient(270deg,#fa865f, #eb263b);
        }
        .bgEND{
           background: #aaaaaa;
        }
      }
      .liveCoverTitle{
        width: 370px;
        height: 90%;
        font-size: 28px;
        color: #030303;
        margin: auto 16px;
        line-height: 40px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        // padding-top: 16px;
      }
      .watch_btn{
        width: 96px;
        height: 52px;
        // padding: 12px 22px;
        background: linear-gradient(270deg,#fa865f, #eb263b);
        border-radius: 26px;
        text-align: center;
        line-height: 52px;
        font-size: 26px;
        margin-right: 16px;
        color: #ffffff;
      }
    }
    .liveList{
      max-height: 230px;
      overflow-y: scroll;
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 -1px 10px #CCB1B1;
      padding:18px 28px;
      box-sizing: border-box;
      -webkit-overflow-scrolling:touch;
      .liveItem{
        display: flex;
        align-items:center;
        margin-bottom: 27px;
        &:last-child{
          margin-bottom: 0;
        }
        .liveNum{
          width: 26px;
          height: 26px;
          line-height: 26px;
          border-radius: 4px;
          background-color: rgba(153,153,153,.2);
          font-size: 20px;
          color: #333;
          text-align:center;
          margin-right: 18px;
          &.num1{
            background-color:rgba(238,54,58,.2);
            color: rgba(238,52,64,1);
          }
          &.num2{
            background-color:rgba(250,133,94,.2);
            color: rgba(250,133,94,1);
          }
          &.num3{
            background-color:rgba(255,183,0,.2);
            color: rgba(255,183,0,1);
          }
        }
        .liveItemBrand{
          font-size: 28px;
          color: #333;
          line-height: 28px;
          margin-bottom: 11px;
          font-weight: 400;
        }
        .liveItemTime{
          color: #666;
          font-size: 22px;
          line-height: 22px;
          font-weight: 500;
        }
      }
    }
    .seeBtn{
      text-align: center;
      margin: 20px auto 0;
      color: #333333;
      font-size: 20px;
      // line-height: 28px;
      img{
        width: 22px;
        height: 12px;
        margin-left: 4px;
      }
    }
  }
  .liveLists{
    // margin-top: 18px;
      display: flex;
      align-items: flex-start;
      overflow: hidden;
    .status_spot{
      // display: inline-block;
      // vertical-align: top;
      position: relative;
      margin: 0 20px;
      .spot{
        position: absolute;
        top:0;
        width: 24px;
        height: 24px;
      }
      .spotLine{
        position: absolute;
        top:6px;
        width: 2px;
        height: 102px;
        left: 11px;
      }
    }
    .liveSessions{
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      div{
        font-size: 28px;
        line-height: 28px;
        color: #333333;
        margin-bottom: 12px;
        max-width: 600px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
      }
      p{
        font-size: 24px;
        line-height: 24px;
        color: #999999;
      }
      .pbottom{
        margin-bottom: 36px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/activity/detail.vue